import '~/js/sections/weddings/includes/stickyNav';
import '~/js/sections/weddings/includes/scroll-below';
// create new array for countries and appending a new object that represents default value
/* eslint-disable */
const countries = [
    {
        name: 'Select a Country',
        id: '',
        regionCode: '',
        code: ''
    },
    ...window.beaches_app.page.countries
];

const countryPhoneCodes = require('~/js/modules/countryCallingCodes');

// create new array for states and appending a new object that represents default value
const states = [...window.beaches_app.page.states];

import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import CustomTextarea from '~/js/components/form-controls/CustomTextarea';

ReactDOM.render(
    <CountryStateSelector
        countries={countries}
        states={states}
        countryName="country"
        stateName="state"
        stateLabelWrapper="lg-5"
        stateInputWrapper="lg-7"
        countryLabelWrapper="lg-5"
        countryInputWrapper="lg-7"
    />,
    document.getElementById('country-state-selector')
);

ReactDOM.render(
    <CustomDatePicker
        name="checkInDate"
        // wrapperClassName="xs-12 lg-7"
        inputClassName="checkin-date-input"
        isRequired
        allowPast
        displayPlaceHolder
        displayStringDate={false}
    />,
    document.getElementById('checkin-datepicker')
);

ReactDOM.render(
    <CustomTextarea
        name="proposalIdea"
        id="proposalIdea"
        maxLength="500"
        displayCharacterCount
        isRequired
    />,
    document.getElementById('react-textarea')
);

ReactDOM.render(
    <CustomRecaptcha wrapperClassName="xs-12 lg-12" />,
    document.getElementById('google-recaptcha')
);

// form validations
import '~/js/modules/fend';

// form elements references
const $countrySelector = $('select[name="country"]');
const $subscribeLabel = $('.form-label[for="subscribe"]');
const $engagementForm = $('#engagement-form');

// Form Validation
$engagementForm.fend({
    rules: {
        firstName: 'lettersOnly',
        lastName: 'lettersOnly',
        bookingNumber: 'alphanumeric',
        city: 'lettersOnly',
        agencyName: 'alphanumeric',
        agentName: 'alphanumeric'
    }
});

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', event => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));
    $('.contact-uk-verbage').show();
    $('.checkSpacer').show();
    if (countryId === 'CA') {
        $('.contact-uk-verbage').hide();
        $('.checkSpacer').hide();
        $subscribeLabel.html($subscribeLabel.data('canada'));
        $('.mob-mar-trigger').removeClass('mob-mar');
    } else {
        $('.mob-mar-trigger').addClass('mob-mar');
    }
});

$(document).ready(() => {
   
    const workingWith = document.querySelectorAll('[name="workingWith"]');
    
    const agencyName = document.getElementById('agencyName');
    const agentName = document.getElementById('agentName');
    const agencyCountry = document.getElementById('taCountry');
    const agencyEmail = document.getElementById('taEmail');
    const agencyAreaCode = document.getElementById('agencyAreaCode');
    const agencyPhoneNumber = document.getElementById('agencyPhoneNumber');

    workingWith.forEach((Item) => {
        Item.addEventListener('click', () => {
            const InfoBlock = document.getElementById('travel_agent');
            if(Item.value === "true"){
                InfoBlock.classList.add("active");

                agencyName.setAttribute("required", "");
                agentName.setAttribute("required", "");
                agencyCountry.setAttribute("required", "");
                agencyEmail.setAttribute("required", "");
            }else{
                InfoBlock.classList.remove("active");

                agencyName.removeAttribute("required");
                agentName.removeAttribute("required");
                agencyCountry.removeAttribute("required");
                agencyEmail.removeAttribute("required");
                agencyAreaCode.removeAttribute("required");
                agencyPhoneNumber.removeAttribute("required");
            }
        })
    });

    const additionAgencyInfo = document.querySelectorAll('[name="addInfoAgency"]');

    additionAgencyInfo.forEach((item) => {
        item.addEventListener('click', () => {
            const agencyEmail = document.getElementById('agency_email');
            const agencyPhone = document.getElementById('agency_phone');
            if(item.value === "email"){
                agencyEmail.classList.add("active");
                agencyPhone.classList.remove("active");

                agencyAreaCode.removeAttribute("required");
                agencyPhoneNumber.removeAttribute("required");
                agencyAreaCode.value = "";
                agencyPhoneNumber.value = "";
                agencyEmail.setAttribute("required", "");
            }else{
                agencyPhone.classList.add("active");
                agencyEmail.classList.remove("active");
                
                agencyEmail.removeAttribute("required");
                agencyEmail.value = "";
                agencyAreaCode.setAttribute("required", "");
                agencyPhoneNumber.setAttribute("required", "");
            }
        })
    });
    $('[name=country]').on('change', function() {
        const selectedCountry = $(this).val();

        countryPhoneCodes.countryCodes.map(function(index) {
            if (selectedCountry === index.code) {
                $('span.countryCode').html(index.dial_code);
            }
        });
    });
    $('[name=termsAndConditionsAccepted]').on('change', function() {
        const checkBox = document.getElementById("subscribe");
        if (checkBox.checked == true){
            $('[for=subscribe]').addClass("active")
          } else {
            $('[for=subscribe]').removeClass("active")
          }
    });

    const countryCodes = countryPhoneCodes.countryCodes.sort(function (a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    }).map(element => `(${element.dial_code}) - ${element.name}`);
    const selectElement = document.getElementById('countryCode');
    const agencyElement = document.getElementById('agencyAreaCode');
    const taCountry = document.getElementById('taCountry');

    countryCodes.forEach((element) => {
        let dialCode = element.split(" -");
        selectElement.add(new Option(element, dialCode[0]));
    });

    countryCodes.forEach((element) => {
        let dialCode = element.split(" -");
        agencyElement.add(new Option(element, dialCode[0]));
    });

    const renderCountryOption = (countryArray = []) => {
        const usaInformation =
            countryArray[countryArray.findIndex(el => el.code === 'US')] || {};
        const canadaInformation =
            countryArray[countryArray.findIndex(el => el.code === 'CA')] || {};
        const ukInformation =
            countryArray[countryArray.findIndex(el => el.code === 'GB')] || {};
        const defaultOption = countryArray[0];
        const filteredCountryArray = countryArray.filter(
            el =>
                el.code !== '' &&
                el.code !== 'US' &&
                el.code !== 'CA' &&
                el.code !== 'GB'
        );

        return [
            defaultOption,
            usaInformation,
            canadaInformation,
            ukInformation,
            ...filteredCountryArray
        ];
    };

    const countriesAgent = renderCountryOption(countries).filter((value, index) => value.name && index != 0);


    countriesAgent.map(x => x.name).forEach((element) => {
        taCountry.add(new Option(element, element));
    });

    // function AreaCode() {
    //     const select_area_code = document.getElementById('area_code');
    //     callingCodesObj.countryCodes.map(function(index) {
    //         var opt = document.createElement('option');
    //         opt.value = index.code;
    //         opt.innerHTML = '('+ index.dial_code + ')' + ' - ' + index.name;
    //         select_area_code.appendChild(opt);
    //     });

    //     if(select_area_code.value === ''){
    //         $('[name=phone]').attr("disabled", "disabled")
    //     }else{
    //         $('[name=phone]').removeAttr("disabled", "")
    //     }

    //     $('[name=area_code]').on('change', function(){
    //         if(select_area_code.value === ' '){
    //             $('[name=phone]').attr("disabled", "disabled");
    //         }else{
    //             $('[name=phone]').removeAttr("disabled", "")
    //         }
    //     });
    // }
    // if($('[name=country]').length > 0) {
    //     AreaCode();
    // }

});
